<template>
  <div class="footer">
    <!-- <footer>©MiniGame Lab. All Rights Reserved.</footer> -->
    <!-- <footer>https://www.hunt-love.com/ belongs to PROMETHEUS HIGH TECHNOLOGY PTE. LTD.</footer> -->
    <div class="wrap">
      <div class="left">
        <a href="/terms">Terms of Service</a>
        <a href="/privacypolicy">Privacy policy</a>
      </div>
      <div class="right">©MiniGame Lab. All Rights Reserved.</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logo_name: "",
    };
  },
  created() {
    this.renderUI();
  },
  methods: {
    renderUI() {
      const config = this.$store.state.data;
      this.logo_name = config.logo_name;
    },
  },
};
</script>

<style lang="less" scoped>
.footer {
  // position: fixed;
  // height: 93px;
  // bottom: 0px;
  width: 100%;
  height: 60px;
  font-family: 'Poppins',sans-serif;
  color: #444;
  // background: #ffffff;
  // text-align: center;
  font-size: 14px;
  // font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  // color: #797979;
  // line-height: 93px;
  // letter-spacing: 1px;
  background-color: #e8e8e8;
  .wrap{
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 1100px;
    margin: 0 auto;
    height: 100%;
  }
  a{
    color: #444;
    text-decoration: underline;
    margin-right: 30px;
    transition: all 500ms ease;
    &:hover{
      color: #000;
    }
  }
}
</style>
